import {
  apiRequest,
  Create,
  Update,
  CreateDetail,
  Submit,
  DownloadTempate,
  gradeList,
  checkPositionQuota,
  LegalList,
  StatusList
} from "../../../../../services/adapters/kepegawaian/mutasiPegawaiService";

class IndexRepository {
  fetchCreate = async (query, cancelToken) => {
    return await apiRequest(
      "post",
      Create,
      {
        body: query,
      },
      true
    );
  };
  fetchUpdate = async (query, cancelToken) => {
    return await apiRequest(
      "post",
      Update,
      {
        body: query,
      },
      true
    );
  };

  fetchCreateDetail = async (query, cancelToken) => {
    return await apiRequest(
      "post",
      CreateDetail,
      {
        body: query,
      },
      true
    );
  };

  fetchSubmit = async (query) => {
    return await apiRequest(
      "post",
      Submit,
      {
        body: query,
      },
      true
    );
  };

  fetchDownloadTemplate = async (query) => {
    return await apiRequest(
      "get",
      DownloadTempate,
      {
        params: query,
      },
      true
    );
  };

  fetchGrade = async (query) => {
    return await apiRequest(
      "get",
      gradeList,
      {
        params: query,
      },
      true
    );
  };

  checkPositionQuota = async (query) => {
    return await apiRequest(
      "get",
      checkPositionQuota,
      {
        params: query,
      },
      true
    );
  };


  fetchLegalList = async (query, cancelToken) => {
    return await apiRequest("get", LegalList, {
        cancelToken: cancelToken,
        params: query
    }, true)
}


  fetchStatusList = async (query, cancelToken) => {
      return await apiRequest("get", StatusList, {
          cancelToken: cancelToken,
          params: query
      }, true)
  }
}

export default IndexRepository;
